import { http, HttpResponse } from 'msw'

interface MockUpdateCardPathParams {
  alphaId: string
  cardAlphaId: string
}

interface MockUpdateDistributionsBody {
  data: {
    creditCardName: string
    holder: string
    number: string
    expireDate: string
    brandCode: string
    description: string
    active: boolean
    companyType: 'AGENCY_CHAIN' | 'AGENCY' | 'SALES_POINT'
    shared: boolean
  }
}

export const mockUpdateCard = http.put<
  MockUpdateCardPathParams,
  MockUpdateDistributionsBody
>('/my-business/api/agency/v1/*/:alphaId/cards/:cardAlphaId', () => {
  return HttpResponse.json(null, { status: 200 })
})
